import { render, staticRenderFns } from "./contenedor.vue?vue&type=template&id=69ded467"
import script from "./contenedor.vue?vue&type=script&lang=js"
export * from "./contenedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports